module.exports = __webpack_public_path__ + "static/media/8.d063e127.jpg";